class MediaRecorderFormat {
    constructor(public readonly mimeType: string, public readonly extension: string) {
    }
}

let audioFormats: MediaRecorderFormat[] = [
    new MediaRecorderFormat("audio/mp3", "mp3"),
    new MediaRecorderFormat("audio/ogg", "ogg"),
    new MediaRecorderFormat("audio/webm", "webm"),
    new MediaRecorderFormat("audio/mp4", "mp4"),
    new MediaRecorderFormat("audio/wav", "wav")
];

export default class VoiceRecorder {
    private mediaRecorder: any;

    constructor(private callback: (result: VoiceRecorderResult) => void) {

    }

    get format(): MediaRecorderFormat | undefined {
        for (let format of audioFormats) {
            if (MediaRecorder.isTypeSupported(format.mimeType)) {
                return format;
            }
        }
        return undefined;
    }

    async start() {
        if ((window as any).MediaRecorder) {
            let format = this.format;
            if (format) {
                let voice: any[] = [];
                let voiceBlob: Blob | undefined;
                let stream = await navigator.mediaDevices.getUserMedia({audio: true});
                // @ts-ignore
                this.mediaRecorder = new MediaRecorder(stream, {
                    mimeType: format.mimeType
                });
                this.mediaRecorder.addEventListener("stop", () => {
                    voiceBlob = new Blob(voice, {
                        type: format.mimeType
                    });
                    this.callback(new VoiceRecorderResult(voiceBlob, format));
                    /*
                    let audio = new Audio()
                    audio.src = window.URL.createObjectURL(voiceBlob);
                    audio.play();
                     */
                });

                this.mediaRecorder.addEventListener("dataavailable", function (event: any) {
                    voice.push(event.data);
                });

                this.mediaRecorder.start();
            } else {
                throw new Error("Не удалось получить формат аудио-файла");
            }
        } else {
            throw new Error("MediaRecorder недоступен");
        }
    }

    stop() {
        if (this.mediaRecorder) {
            this.mediaRecorder.stop();
        }
    }

}

export class VoiceRecorderResult {
    private _audio: HTMLAudioElement;

    constructor(private _blob: Blob, public readonly format: MediaRecorderFormat) {
        this._audio = new Audio()
        this._audio.src = window.URL.createObjectURL(this._blob);
    }

    public get duration() {
        return this.audio.duration;
    }

    public get audio() {
        return this._audio;
    }

    public get blob() {
        return this._blob;
    }
}